import { Trans } from "@lingui/react/macro";
import { BlockContentValue, Icon } from "@silversea-ssc/ui-components-react";
import React from "react";
import * as styles from "./ThankYoyBox.module.scss";
import TextBox from "components/TextBox/TextBox";

type Props = {
  title: string | undefined;
  content: BlockContentValue | undefined;
};

const ThankYouBox: React.FC<Props> = ({ title, content }) => {
  return (
    <div className={styles.box}>
      <div className={styles.subscriptionConfirmedMessage}>
        <Icon name="circle-check" size="1x" padding="inline-right" />
        <Trans id="form-successfully-submitted">Successfully submitted</Trans>
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.content}>
        <TextBox content={content} fontSize="inherit" />
      </div>
    </div>
  );
};

export default ThankYouBox;
